<template>
  <div>
    <van-form @submit="onSubmit">
      <van-field
        :disabled="disabled || testingAmount == 0"
        v-model="formData.name"
        name="name"
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field name="sex" label="性别">
        <template #input>
          <van-radio-group :disabled="disabled" v-model="formData.sex.key" direction="horizontal">
            <van-radio name="Female">女</van-radio>
            <van-radio name="Male">男</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 生日 -->
      <van-field
        :disabled="disabled"
        v-model="formData.birth"
        is-link
        name="datetimePicker"
        label="出生日期"
        readonly
        placeholder="点击选择生日"
        @click="showPickerBirth = true"
      />
      <van-popup v-if="!disabled" v-model="showPickerBirth" position="bottom">
        <van-datetime-picker
          type="date"
          v-model="defaultDate"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onConfirmBirth"
          @cancel="showPickerBirth = false"
        />
      </van-popup>
      <!-- 身高 -->
      <van-field name="height" label="身高（cm）">
        <template #input>
          <van-stepper :disabled="disabled" v-model="formData.height" step="1"  min="35" max="200" theme="round" button-size="22" />
        </template>
      </van-field>
      <!-- 体重 -->
      <van-field name="weight" label="体重（kg）">
        <template #input>
          <van-stepper :disabled="disabled" v-model="formData.weight" step="0.1" :decimal-length="1" min="1" max="250" theme="round" button-size="22" />
        </template>
      </van-field>
      <slot/>
      <div style="margin-top: 16px;">
        <van-button round block type="primary" native-type="submit" color="#ff9e19">
          {{ buttonLabel }}
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Filter from "../../utils/filter"
import { Toast } from 'vant'
export default {
  props: {
    testingAmount: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    },
    buttonLabel: {
      type: String,
      default: '立即修改'
    }
  },
  watch: {
    data(val) {
      this.fillData(val)
    }
  },
  data() {
    return {
      customFieldName: {
        text: 'name'
      },
      month: '',
      minDate: new Date(2000, 1, 1),
      maxDate: new Date(),
      defaultDate: new Date(2022, 1, 1),
      showPickerBirth: false, 
      formData: {
        height: 60,
        weidht: 5,
        sex: {}
      }
    };
  },
  components: {
  },
  created() {
  },
  methods: {
    onSubmit() {
      // 提交
      this.$emit('submit', this.formData)
    },
    onConfirmBirth(val) {
      this.formData.birth = Filter.formatDateTime(val)
      this.showPickerBirth = false
    },
    fillData(res) {
      this.formData = res
      if (!res.state) {
        this.formData.state = {}
      }
      if (!res.type) {
        this.formData.type = {}
      }
      if (!res.sex) {
        this.formData.sex = {}
      }
      if (!res.height) {
        this.formData.height = 60
      }
      if (!res.weight) {
        this.formData.weight = 5
      }
      if (res.birth) {
        this.defaultDate = new Date(res.birth.replaceAll('-', '/'))
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../assets/css/style.css');
.block {
  margin-top: 40px;
  padding: 0 40px;
}
</style>